import { useTranslation } from 'react-i18next';

export default function Stats() {
  const { t } = useTranslation()

  const stats = [
    { id: 1, name: t('stats.s1.name'), value: t('stats.s1.value') },
    { id: 2, name: t('stats.s2.name'), value: t('stats.s2.value') },
    { id: 3, name: t('stats.s3.name'), value: t('stats.s3.value') },
  ]

  return (
    <div className="bg-gradient-to-r from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90% py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
          {stats.map((stat) => (
            <div key={stat.id} className="mx-auto flex max-w-xs flex-col gap-y-4">
              <dt className="text-base leading-7 text-gray-800">{stat.name}</dt>
              <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}
